module.exports = __webpack_public_path__ + "img/verpak_jumpax_classic.5c74c7b6.jpg";